import React, { Component } from 'react'

import { Row, Col } from 'antd'

import ColumnTitle from '../ColumnTitle'

import xctit from '../../assets/img/xctit.png'

import playImage from '../../assets/img/play.png'

import pos1 from '../../assets/img/pos1.jpg'

import pos2 from '../../assets/img/pos2.jpg'

import lt1 from '../../assets/img/lt1.jpg'
import lt2 from '../../assets/img/lt2.jpg'
import lt3 from '../../assets/img/lt3.jpg'
import lt4 from '../../assets/img/lt4.jpg'

import { TheDirectWrapper, VideoContentWrapper, VideoContent, VideoList } from './style'

export default class TheDirect extends Component {
    state = {
        current: 0,
        showVideo: false,
        list: [
            {
                id: '001',
                txt: '当智库遇上元宇宙，会有什么发生？',
                sub: '当智库遇上元宇宙，会有什么发生？',
                imgSrc: pos1,
                videoSrc: 'https://vodpub1.v.news.cn/original/20220105/44be90420aa1458eb31409181f646274.mp4'
            },
            {
                id: '002',
                txt: '智库专家谈｜展望2022：中国经济下一程',
                sub: '智库专家谈｜展望2022：中国经济下一程',
                imgSrc: pos2,
                videoSrc: 'https://vodpub1.v.news.cn/original/20220105/3dc06db4a4614262842c48b621101b82.mp4'
            },
            {
                id: '003',
                txt: '回放|后疫情时代的全球与中国经济',
                sub: '',
                imgSrc: lt1,
                videoSrc: 'https://review.v.news.cn/review/basics/live23117/20211228/0857019329_mp4/085701_9329_5000k.mp4'
            },
            {
                id: '004',
                txt: '回放|科技创新与产业革命',
                sub: '',
                imgSrc: lt2,
                videoSrc: 'https://vodpub1.v.news.cn/original/20211229/76d9fbde5b9047879315118ac8221db2.mp4'
            },
            {
                id: '005',
                txt: '回放|新一轮产业变革下的挑战与机遇',
                sub: '',
                imgSrc: lt3,
                videoSrc: 'https://vodpub1.v.news.cn/original/20211229/e8f85a8cb46344d4b2752bd65a47ca2a.mp4'
            },
            {
                id: '006',
                txt: '回放|常态化防控与公共卫生体系建设',
                sub: '',
                imgSrc: lt4,
                videoSrc: 'https://vodpub1.v.news.cn/original/20211229/339910c256ac4972b6b1339084134530.mp4'
            },
        ]
    }
    handleClick = () => {
        return (node) => {
            const { value } = node.target.attributes.number
            const { h2Node, pNode, posterNode, myVideo } = this
            const { list } = this.state
            this.setState({
                current: value * 1,
                showVideo: false
            })
            h2Node.innerText = list[value].txt
            pNode.innerText = list[value].sub
            posterNode.src = list[value].imgSrc
            myVideo.pause()
        }
    }
    handlePlay = () => {
        const { current, list } = this.state

        const { myVideo } = this

        this.setState({
            showVideo: true
        })

        myVideo.src = list[current].videoSrc

        myVideo.play()
    }
    render() {
        const { current, list, showVideo } = this.state
        return (
            <TheDirectWrapper>
                <ColumnTitle imgSrc={xctit} />
                <VideoContentWrapper>
                    <Row>
                        <Col span={18}>
                            <VideoContent>
                                <div className="videoBox">
                                    <img ref={c => this.posterNode = c} className="posterImage" src={pos1} alt="" />
                                    <img onClick={this.handlePlay} className="play" src={playImage} alt="" />
                                    <div className="videoWrap" style={{ display: showVideo ? 'block' : 'none' }}>
                                        <video
                                            ref={c => { this.myVideo = c }}
                                            className="myVideo"
                                            preload="auto"
                                            autobufer="true"
                                            webkit-playsinline="true"

                                            x5-video-player-type="h5"
                                            x5-video-orientation="landscape|portrait"
                                            x5-video-player-fullscreen="true"
                                            x-webkit-airplay="allow"
                                            src=""
                                        ></video>
                                    </div>
                                </div>
                                <div className="textBox">
                                    <h2 ref={c => this.h2Node = c}>当智库遇上元宇宙，会有什么发生？</h2>
                                    <p ref={c => this.pNode = c}>当智库遇上元宇宙，会有什么发生？</p>
                                </div>
                            </VideoContent>
                        </Col>
                        <Col span={6}>
                            <VideoList>
                                {
                                    list.map((item, index) => {
                                        return (
                                            <li
                                                key={item.id}
                                                number={index}
                                                className={current === index ? 'current' : ''}
                                                onClick={this.handleClick()}
                                            >{item.txt}<span className="icon" /></li>
                                        )
                                    })
                                }
                            </VideoList>
                        </Col>
                    </Row>
                </VideoContentWrapper>
            </TheDirectWrapper>
        )
    }
}
